// Layout planner: turns an event document into an ordered list of pages
// ({ kind, props }). Keeps the renderer dumb and makes the page sequence testable.
// Page SELECTION now lives per event type: each type may export planPages(event);
// types without one fall back to defaultPlanPages (the historical sequence).

import { getEventType } from "../../eventTypes/index.js";
import { defaultPlanPages } from "./sections.js";

export function planPages(event) {
  if (!event) return [];

  // source === "images": uploaded images ARE the brochure, shown directly.
  // Universal across all event types.
  if (event.source === "images" && (event.imagePageUrls || []).length) {
    return event.imagePageUrls.map((url, i) => ({ kind: "image", props: { url, alt: `Page ${i + 1}` } }));
  }

  // source === "build": delegate to the event type's own page plan.
  const type = getEventType(event.eventType);
  return (type?.planPages ?? defaultPlanPages)(event);
}
